<template>
  <v-container>
    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>
      <v-col class="d-flex" cols="12">
        <!-- <chipSimulador :properties="chipArray"></chipSimulador> -->

        <!-- <v-tooltip bottom color="#1b1b1b">
          <template v-slot:activator="{ on }">
            <v-btn
              class="ml-2"
              @click="resetSelects"
              v-on="on"
              fab
              dark
              x-small
              color="success"
              ><v-icon dark> mdi-refresh </v-icon>
            </v-btn>
          </template>
          <span>Refrescar selectores</span>
        </v-tooltip> -->
      </v-col>

      <v-col cols="12" sm="3" md="" class="py-0">
        <v-autocomplete label="Estudiante" :items="AlumnosPadre" autocomplete="off" v-model="alumno"
          item-value="id_alumno" item-text="persona.nombre_completo" @change="getAllAreasFamilia(alumno)" return-object>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="" class="py-0">
        <div class="nivel">
          <p>Nivel</p>
          <span>{{ NivelAlumno }}</span>
        </div>
      </v-col>
      <v-col cols="12" sm="3" md="" class="py-0">
        <div class="grado">
          <p>Grado</p>
          <span>{{ GradoAlumno }}</span>
        </div>
      </v-col>
      <v-col cols="12" sm="3" md="" class="py-0">
        <div class="seccion">
          <p>Sección</p>
          <span> {{ SeccionAlumno }}</span>
        </div>
      </v-col>

      <v-col cols="12" sm="3" md="" class="py-0">
        <v-autocomplete label="Simular por área" :items="ItemArea" :disabled="inhabilitarAreaFam" autocomplete="off"
          item-value="id" item-text="desc_area" v-model="MoArea" @change="seleccionarArea(MoArea)" return-object>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="3" md="" class="py-0">
        <v-autocomplete label="Simular por curso" :items="ItemCurso" :disabled="inhabilitarCursoFam" autocomplete="off"
          item-value="id_curso" item-text="desc_curso" v-model="MoCurso" @change="seleccionarCurso(MoCurso)">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" class="d-flex justify-center">
        <v-alert v-if="botonArea" dense outlined color="primary">
          <v-btn @click="openDialogSimulador(null, 'byArea', null)" small color="primary" plain><v-icon size="25"
              left>mdi-book-open-page-variant </v-icon>
            SIMULAR EXAMEN POR ÁREA
          </v-btn>
        </v-alert>
        <v-alert v-if="botonCurso" dense outlined color="primary">
          <v-btn @click="openDialogSimulador(null, 'byCurso', null)" small color="primary" plain><v-icon size="25"
              left>mdi-book-open-page-variant </v-icon>
            SIMULAR EXAMEN POR CURSO
          </v-btn>
        </v-alert>
      </v-col>

      <v-col cols="12">
        <v-sheet color="grey" class="" v-if="readyload">
          <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
        </v-sheet>

        <v-data-table v-else :headers="headersUnidad" :search="searchTemasClases" :items="itemsTemasClases"
          :no-data-text="'No hay datos disponibles, seleccionar Filtros'" group-by="nombre_tema" sort-by="nombre_tema">

          <template v-slot:[`item.autor`]="{ item }">
            <v-chip small dark class="font-weight-black" :class="item.tipo_contenido == 1 ? 'btn_virtual' : 'grey'">
              {{ item.tipo_contenido == 1 ? '🤵Inteligenio' : '🧑‍🎓Colegio' }}
            </v-chip>
          </template>

          <template v-slot:[`item.accion_preguntar`]="{ item }">
            <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                <v-btn loader-color="yellow darken-3" v-on="on" small color="primary"
                  :class="classAnimate + ' ma-2 white--text'" @click="
                    openDialogSimulador(
                      item,
                      'byClase',
                      item.id_clase
                    )
                    ">
                  <v-icon left>mdi-comment-question-outline</v-icon>
                  CREAR SIMULADOR DE EXAMEN
                </v-btn>
              </template>
              <span>Crear simulador de examen</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.accion_ver`]="{ item }">
            <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                <v-btn :loading="loadingBanco[item.id_clase]" :disabled="loadingBanco[item.id_clase]" v-on="on"
                  class="btn_editar px-0 mx-0" fab x-small @click="verBancoPreguntas(item)">
                  <v-icon>fa-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver banco de preguntas</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog transition="dialog-transition" max-width="600" v-model="dialogCreaSimuladorMasivo">
      <v-card>
        <v-toolbar color="primary" dark>{{
          tituloSimuladorMasivo }}
          <v-spacer></v-spacer>
          <v-btn fab dark x-small class="btn_style3" @click="dialogCreaSimuladorMasivo = false">
            <v-icon dark>fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <!-- <v-list two-line subheader> -->
          <br />
          <v-row>
            <v-col class="" cols="12">
              <v-autocomplete v-model="temasRelacionadosArray" :items="temasRelacionadosArray" :readonly="true" filled
                chips color="blue-grey lighten-2" label="Clases relacionadas" item-text="nombre_clase"
                item-value="nombre_clase" multiple>
                <template v-slot:selection="data">
                  <v-chip close>
                    <v-avatar color="brown">
                      <v-icon size="15" dark>mdi-book-open-page-variant</v-icon>
                    </v-avatar>
                    &nbsp;{{ data.item.nombre_clase }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title> Clase </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ data.item.nombre_clase }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn @click="simularExamen(arrayClasesAreas)" :loading="loadingMasivo" :disabled="loadingMasivo" depressed
            color="primary">
            <v-icon left>mdi-comment-question-outline</v-icon>
            {{ tituloBotonSimularExamen }}
            <!-- FINALIZAR PROGRAMACIÓN -->
          </v-btn>
        </v-card-actions>
        <br />
      </v-card>
    </v-dialog>

    <!------------------------------------->
    <!-- DRAWER EXTRA BANCO DE PREGUNTAS -->
    <!------------------------------------->
    <v-navigation-drawer width="450" app v-model="verPreguntaDrawer" fixed temporary right>
      <v-toolbar dark color="primary">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              <v-icon class="animate__animated animate__heartBeat animate__infinite" right>
                mdi-comment-question-outline</v-icon>
              Banco de preguntas
            </v-list-item-title>
            <!-- <v-list-item-subtitle class="ml-3">
              de preguntas
            </v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="verPreguntaDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list rounded v-if="arrayPreguntasClase.length == 0">
        <v-alert :class="classAlertanimate" dense outlined type="error">
          Aun no existen <strong>preguntas</strong> para esta
          <strong>clase </strong>
        </v-alert>
      </v-list>
      <v-list v-else dense nav>
        <ol>
          <v-list-item v-for="item in arrayPreguntasClase" :key="item.idpregunta" link>
            <li v-html="item.titulo"></li>
          </v-list-item>
        </ol>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
export default {
  name: "simuladorPadreFamiliaInicial",
  components: {
    // chipSimulador: () => import("../components/Co-chipSimulador.vue"),
  },
  data: () => ({
    // PROPIEDAD  DEL COMPONENTE CHIP
    chipArray: [
      {
        color: "amber accent-4",
        label: true,
        dark: true,
        dataText: "Selecciona información",
        icon: "mdi-arrow-down",
      },
    ],
    //  PROPIEDAD DEL COMPONENTE VSELECT
    searchTemasClases: null,
    datoLogin: sessionStorage,
    paramsClases: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_alumno: null,
      id_area: null,
      id_curso: null,
      fecha_inicio: null,
      fecha_fin: null,
    },
    itemsTemasClases: [],
    // LOGICA DE SKELETON
    readyload: false,
    // LOGICA DE TEMAS Y CLASES Y POBLACION DE DATOS
    headersUnidad: [
      { text: "GRADO", value: "desc_grado" },
      { text: "UNIDAD", value: "nombre_tema" },
      { text: "TEMA", value: "nombre_clase" },
      { text: "AUTOR", value: "autor" },
      { text: "CREAR SIMULADOR", value: "accion_preguntar", sortable: false },
      {
        text: "VER BANCO DE PREGUNTAS",
        value: "accion_ver",
        sortable: false,
        align: "center"
      },
    ],
    loadingBanco: [],
    loadingMasivo: false,
    // CLASS ANIMATE
    classAnimate: "",
    classAlertanimate: "",

    //OBTENER EL NOMBRE DE PERFIL
    detallePerfil: "",

    // SIDEBAR DE BANCO DE PREGUNTAS
    verPreguntaDrawer: false,

    // LISTAR PREGUNTAS POR CLASE
    arrayPreguntasClase: [],

    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 2000,
    SnackbarTextAlert: "",

    dialogCreaSimuladorMasivo: false,
    itemAlumnosSelected: [],

    usedCodes: [],

    // LOGICA EXCLUSIVO
    arrayClasesAreas: [],
    tituloSimuladorMasivo: "null",

    tituloBotonSimularExamen: "null",


    // variable iniciales
    botonArea: false,
    ValorbotonArea: null,
    botonCurso: false,
    ValorbotonCurso: null,

    // LOGICA DEL PADRE DE FAMILIA
    EstudianteUsuarioId: null,
    AlumnosPadre: [],
    ItemArea: [],
    ItemCurso: [],
    MoArea: [],
    MoCurso: [],
    alumno: [],
    NivelAlumno: "",
    GradoAlumno: "",
    SeccionAlumno: "",

    // variable iniciales
    inhabilitarAreaFam: true,
    inhabilitarCursoFam: true,

    itemsTemasClasesFiltro: [],
    temasRelacionadosArray: [],
  }),
  methods: {
    /*-------------------------------*/
    /* METODO RESET SELECTS Y LISTAR */
    /*-------------------------------*/
    async resetSelects() { },

    /*------------------------------------------*/
    /* FUNCION OBTENER DATOS DE TODAS LAS AREAS */
    /*------------------------------------------*/
    async getAllAreasFamilia(alumno) {
      const me = this;

      console.log(alumno);

      me.paramsClases.id_alumno = alumno.id_alumno;
      me.NivelAlumno = alumno.desc_nivel;
      me.GradoAlumno = alumno.desc_grado;
      me.SeccionAlumno = alumno.nombre_seccion;

      try {
        const response = await axios.post(
          "/academico/padre/all/alu/ars/",
          me.paramsClases
        );

        me.listarClases();

        me.obtenerAlumnoUsuario(alumno["persona.id"]);
        me.ItemArea = response.data;
        me.inhabilitarAreaFam = false;
      } catch (error) {
        console.log(error);
      }
    },

    /*-----------------------*/
    /* FUNCION SELECTOR AREA */
    /*-----------------------*/
    async seleccionarArea(nivel) {
      const me = this;
      me.listarClases();
      me.paramsClases.id_area = nivel.id;
      me.paramsClases.fecha_inicio = null;
      me.paramsClases.fecha_fin = null;

      me.itemsTemasClases = me.itemsTemasClasesFiltro.filter(
        (el) => el.id_area == nivel.id
      );

      try {
        const response = await axios.post(
          "/academico/padre/all/alu/curs/",
          me.paramsClases
        );

        console.log('responseresponse', response);

        me.ItemCurso = response.data;
        me.inhabilitarCursoFam = false;

        me.botonArea = true;
        me.ValorbotonArea = nivel.id;
        me.botonCurso = false;
        me.ValorbotonCurso = null;
      } catch (error) {
        console.log(error);
      } finally {
        // me.openDialogSimulador(null, 'byArea', null)
      }
    },

    /*------------------------*/
    /* FUNCION SELECTOR CURSO */
    /*------------------------*/
    async seleccionarCurso(area) {
      const me = this;
      me.botonCurso = true;
      me.ValorbotonCurso = area.id_curso;
      me.botonArea = false;
      me.ValorbotonArea = null;

      setTimeout(() => {
        me.openDialogSimulador(null, 'byCurso', null)
      }, 500);

    },

    /*----------------------------*/
    /* METODO ABRIR MODAL ALUMNOS */
    /*----------------------------*/
    openDialogSimulador(item, string, claseUnique) {
      const me = this;
      me.arrayClasesAreas = [];
      me.temasRelacionadosArray = [];
      me.dialogCreaSimuladorMasivo = true;

      switch (string) {
        case "byArea":
          me.itemsTemasClases.forEach((clase) => {
            if (clase.tipo_contenido == 1) {
              me.arrayClasesAreas.push(clase.id_clase);
            }
            me.temasRelacionadosArray.push({
              nombre_clase: clase.nombre_clase,
            });
          });

          me.tituloSimuladorMasivo = "Programar examen por área";
          me.tituloBotonSimularExamen = "FINALIZAR PROGRAMACIÓN"
          break;

        case "byCurso":
          me.itemsTemasClases.forEach((clase) => {
            me.arrayClasesAreas.push(clase.id_clase);
            if (clase.tipo_contenido == 1) {
              me.arrayClasesAreas.push(clase.id_clase);
            }
            me.temasRelacionadosArray.push({
              nombre_clase: clase.nombre_clase,
            });
          });

          me.tituloSimuladorMasivo = "Programar examen por curso";
          me.tituloBotonSimularExamen = "FINALIZAR PROGRAMACIÓN"
          break;

        case "byClase":
          if (item.tipo_contenido == 1) {
            me.arrayClasesAreas.push(claseUnique);
          } else {
            me.arrayClasesAreas.push(0);
          }
          me.temasRelacionadosArray.push({
            nombre_clase: item.nombre_clase,
          });
          me.tituloSimuladorMasivo = "Programar examen por clase";
          me.tituloBotonSimularExamen = "CREAR SIMULACRO DE EXAMEN"
          break;

        default:
          break;
      }

      // console.log('itemsTemasClases',me.itemsTemasClases);
      // console.log('arrayClasesAreas',me.arrayClasesAreas);
      // console.log('temasRelacionadosArray',me.temasRelacionadosArray);
    },
    /** 
     __________________________________
    |  MÉTODO VER BANCO DE PREGUNTAS */
    async verBancoPreguntas(item) {
      // * Determinar el tipo de contenido
      const me = this;
      me.loadingBanco[item.id_clase] = true;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      if (item.tipo_contenido == 0) {

        me.arrayPreguntasClase = [];
        setTimeout(async () => {
          NProgress.done();
          me.verPreguntaDrawer = true;
          me.loadingBanco[item.id_clase] = false;
          me.classAlertanimate = "animate__animated animate__bounceIn";
        }, 800);

      } else {

        try {

          const response = await axios.get(
            "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/" +
            item.id_clase
          );

          me.arrayPreguntasClase = response.data;
          setTimeout(async () => {
            NProgress.done();
            me.verPreguntaDrawer = true;
            me.loadingBanco[item.id_clase] = false;
            me.classAlertanimate = "animate__animated animate__bounceIn";
          }, 800);

        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }

      }
    },
    /**
     ___________________________________
    |  FUNCIÓN GENERAR CÓDIGOS RANDOM */
    generateRandomCode(length) {
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let code = "";

      while (code.length < length) {
        let randomChar = characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        code += randomChar;
      }

      if (this.usedCodes.includes(code)) {
        // If the code is already used, generate a new one recursively
        return this.generateRandomCode(length);
      }

      this.usedCodes.push(code);
      return code;
    },
    /** 
     __________________________________
    |  FUNCION CREAR EXAMEN ALEATORIO */
    async simularExamen(clases) {
      // * Define si clases es array o valor númerico simple
      const me = this;

      if (me.temasRelacionadosArray.length == 0) {

        me.snackbarAlert = true;
        me.colorsnackbarAlert = "red";
        me.SnackbarTextAlert = "No hay clases para esta sección";

        return
      }


      let ClasesArray = [];
      let Usuarios = [];
      me.loadingMasivo = true;
      ClasesArray = clases;
      Usuarios[0] = this.EstudianteUsuarioId;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/" +
          ClasesArray
        );
        if (response.data.length != 0) {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();

          let map = new Map();
          response.data.forEach((currentValue) => {
            map.has(currentValue.idpregunta)
              ? map.get(currentValue.idpregunta).push({
                estado: currentValue.estado,
                pregunta: currentValue.pregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta,
              })
              : map.set(currentValue.idpregunta, [
                {
                  estado: currentValue.estado,
                  pregunta: currentValue.pregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta,
                },
              ]);
          });

          const arr = Array.from(map, ([idpregunta, respuestas]) => {
            return { idpregunta, respuestas };
          });

          const PreguntaArrayRandom = [];
          const arrayMapRandom = arr;
          var obj = arrayMapRandom.sort(() => Math.random() - 0.5);
          for (let i = 0; i < 5; i++) {
            PreguntaArrayRandom.push(obj[i]);
          }

          console.log(PreguntaArrayRandom);
          console.log(Usuarios);

          await me.guardarDetalleExamen(PreguntaArrayRandom, clases, Usuarios);
        } else {
          setTimeout(async () => {
            me.loadingMasivo = false;
            me.snackbarAlert = true;
            me.colorsnackbarAlert = "red";
            me.SnackbarTextAlert = "No hay preguntas para esta clase";
            me.dialogCreaSimuladorMasivo = false;
            me.itemAlumnosSelected = [];
          }, 500);
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*---------------------------------------*/
    /* FUNCION GUARDAR EXAMEN DETALLE ALUMNO */
    /*---------------------------------------*/
    async guardarDetalleExamen(itemRespuestas, clases, usuarios) {
      const me = this;

      itemRespuestas.forEach((obj) => {
        obj.idexamen = "";
        obj.valor_pregunta = false;
        obj.respuestas;
      });

      try {
        let fecha = new Date();
        let dia = fecha.getDay();
        let milisegundos = dia + fecha.getMilliseconds();
        let codigoRan = me.generateRandomCode(6);
        await axios.post(
          "/simulador/simuladorExamen/simuladorExamenes/simuladorE/registraExamen",
          {
            usuarios: usuarios,
            perfil: this.datoLogin.licencia_perfil.toUpperCase(), //VALIDAR QUE SIEMPRE SEA EL PADRE DE FAMILIA QUIEN EJECUTE ESTO
            descripcion: "",
            observacion: "",
            codigo: `EX${milisegundos}-${codigoRan}`,
            calificacion: "",
            estado: true,
            idautor: me.datoLogin.id,
            tipo_muestra: "SIMULADOR",
            clases: clases,
            prioridad: 0,
            id_ano_lectivo: +me.datoLogin.id_ano_lectivo,
            id_colegio: +me.datoLogin.id_colegio,
            respuestas: itemRespuestas,
          }
        );
        setTimeout(async () => {
          NProgress.done();

          this.$router.push("/lista_familia_simuladores");
          me.$store.commit("changedStateTab");
          // me.tab = "tab-2";
          // me.tab2ClassAnimate = "animate__animated animate__heartBeat";
          // me.claseAnimada = "animate__animated animate__bounceIn";

          setTimeout(() => {
            // me.tab2ClassAnimate = "";
            // me.claseAnimada = "";
          }, 700);
        }, 800);
        // me.dialogCreaSimuladorMasivo = false;
        // me.itemAlumnosSelected = [];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*---------------------------------------*/
    /* FUNCION GUARDAR EXAMEN DETALLE ALUMNO */
    /*---------------------------------------*/
    async obtenerAlumnoPadre() {
      const me = this;
      try {
        let params = {
          id_colegio: me.datoLogin.id_colegio,
          id_persona: me.datoLogin.id_persona,
          id_anio_lectivo: me.datoLogin.id_ano_lectivo,
        };
        const response = await axios.post("/academico/padre/all/alu/", params);
        this.AlumnosPadre = response.data;

        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    /*------------------------------------*/
    /* FUNCION OBTENER USUARIO DEL ALUMNO */
    /*------------------------------------*/
    async obtenerAlumnoUsuario(id_persona) {
      try {
        const response = await axios.get(
          `/simulador/simuladorExamen/simuladorMuestras/simuladorM/getUsuAlumno/${id_persona}`
        );
        this.EstudianteUsuarioId = response.data.id;
      } catch (error) {
        console.log(error);
      }
    },

    /*------------------------------------------*/
    /* FUNCION LISTAR CLASES DEL HIJO DEL PADRE */
    /*------------------------------------------*/
    async listarClases() {
      const me = this;
      NProgress.start();
      me.$store.commit("mostrarLoading", {
        titulo: "Cargando módulo...",
        color: "#fff",
        colorDialog: "#212121",
        ancho: 300,
      });

      try {
        const response = await axios.post(
          "/academico/padre/all/alu/class/",
          me.paramsClases
        );

        setTimeout(async () => {
          me.itemsTemasClases = response.data;
          me.itemsTemasClasesFiltro = response.data;
          NProgress.done();
          me.$store.commit("ocultarLoading");
          // me.readyloadStuden = false;
        }, 300);
      } catch (error) {
        console.log(error);
      }
    },

    /*----------------*/
    /* FUNCION INICIO */
    /*----------------*/
    // async init() {
    //   const me = this;

    //   try {
    //     const response = await axios.get(
    //       "/simulador/simuladorExamen/simuladorExamenes/simuladorE/capturePerfil/" +
    //         me.datoLogin.id_perfil
    //     );

    //     console.log(response.data["descripcion_perfil"]);
    //     me.detallePerfil = response.data["descripcion_perfil"];

    //     console.log();
    //   } catch (e) {
    //     (console.error || console.log).call(console, e.stack || e);
    //   }
    // },
  },
  mounted() {
    this.obtenerAlumnoPadre();
  },
  // created() {
  //   this.init();
  // },
};
</script>
<style scoped>
.barra {
  height: 300px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-content: center;
  display: flex;
  margin-top: 25px;
}

.programada {
  background: #6d6d6d;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 0;
}

.ejecutada {
  background: #6abf69;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 20%;
}

.sin-ejecutar {
  background: #e53935;
  width: 20%;
  bottom: 0px;
  position: absolute;
}

.reprogramada {
  background: #ffbc00;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 60%;
}

.actualizada {
  background: #ffbc00;
  width: 20%;
  bottom: 0px;
  position: absolute;
  right: 0;
}

.programada h2 {
  position: absolute;
  left: 33%;
  font-size: 20px;
  bottom: 8px;
}

.ejecutada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
  text-align: center;
}

.sin-ejecutar h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

.reprogramada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

.actualizada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

#programada {
  position: absolute;
  left: 5%;
  font-size: 16px;
  color: #6d6d6d;
  bottom: 14%;
}

#ejecutada {
  position: absolute;
  color: #6abf69;
  font-size: 16px;
  left: 26%;
  bottom: 14%;
}

#reprogramada {
  font-size: 16px;
  position: absolute;
  color: #ffbc00;
  left: 62%;
  bottom: 14%;
}

#sin-ejecutar {
  position: absolute;
  font-size: 15px;
  bottom: 14%;
  left: 45%;
  color: #e53935;
}

#actualizada {
  position: absolute;
  right: 7%;
  color: #ffbc00;
  bottom: 14%;
  font-size: 15px;
}

.nivel,
.grado,
.seccion {
  width: 100%;
  height: 50px;
  position: relative;
  border-bottom: 1px solid #1565c0;
}

.nivel span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.seccion span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.grado span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.nivel p {
  font-size: 13px;
}

.grado p {
  font-size: 13px;
}

.seccion p {
  font-size: 13px;
}

@media (max-width: 425px) {
  .seccion {
    margin-bottom: 10px;
  }
}

#contenedor {
  margin-bottom: 100px;
}

.card-alumnos {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid #b7babb;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 2px 9px 3px #b7babb;
  padding-bottom: 5px;
}

.title-alumnos {
  width: 100%;
  height: 20px;
  background: #0c67b8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.alumno {
  width: 100%;
  padding-top: 9px;
  padding-left: 8px;
}

.title-alumnos h5 {
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}

.sin-alumnos {
  width: 100%;
  height: 30px;
  background: #facc1e;
  text-align: center;
  margin-top: 5px;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
}
</style>
